// extracted by mini-css-extract-plugin
export var chatHtmlText = "_r7-2";
export var chatLink = "_r7-0";
export var chatText = "_r7-1";